import { render } from "./WorkItem.vue?vue&type=template&id=51ca1702&scoped=true&lang=true"
import script from "./WorkItem.vue?vue&type=script&lang=js"
export * from "./WorkItem.vue?vue&type=script&lang=js"

import "./WorkItem.vue?vue&type=style&index=0&id=51ca1702&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51ca1702"]])

export default __exports__